import { render, staticRenderFns } from "./CurrentDownload.vue?vue&type=template&id=3a8d6bcc&"
import script from "./CurrentDownload.vue?vue&type=script&lang=js&"
export * from "./CurrentDownload.vue?vue&type=script&lang=js&"
import style0 from "./CurrentDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports